import { Link } from "react-router-dom";
import { resolveImageUrl } from "@/lib/api";
import { trackAmazonClick } from "@/lib/analytics";

export default function ProductCard({ product }) {
  const imgSrc = resolveImageUrl(product.image_url);
  const detailPath = product.slug ? `/products/${product.slug}` : null;

  return (
    <div
      data-testid={`product-card-${product.id}`}
      className="bg-white border-2 border-[#1E1E24] rounded-3xl shadow-[8px_8px_0px_0px_#1E1E24] hover:-translate-y-2 hover:shadow-[12px_12px_0px_0px_#1E1E24] transition-all overflow-hidden flex flex-col p-5 group"
    >
      {detailPath ? (
        <Link to={detailPath} className="block" data-testid={`product-image-link-${product.id}`}>
          <div className="rounded-2xl overflow-hidden mb-5 border-2 border-[#1E1E24] aspect-[4/3] bg-[#F4F1EA] relative">
            {imgSrc ? (
              <img
                src={imgSrc}
                alt={product.name}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center text-6xl">🦡</div>
            )}
          </div>
        </Link>
      ) : (
        <div className="rounded-2xl overflow-hidden mb-5 border-2 border-[#1E1E24] aspect-[4/3] bg-[#F4F1EA] relative">
          {imgSrc ? (
            <img src={imgSrc} alt={product.name} className="w-full h-full object-cover" loading="lazy" />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-6xl">🦡</div>
          )}
        </div>
      )}

      {detailPath ? (
        <Link to={detailPath} data-testid={`product-title-link-${product.id}`} className="hover:text-[#FF5A5F] transition-colors">
          <h3 className="font-headings text-xl font-bold text-[#1E1E24] mb-2 line-clamp-1">
            {product.name}
          </h3>
        </Link>
      ) : (
        <h3 className="font-headings text-xl font-bold text-[#1E1E24] mb-2 line-clamp-1">
          {product.name}
        </h3>
      )}

      <p className="text-[#5E5E66] text-sm mb-6 line-clamp-2 flex-1">
        {product.description}
      </p>
      <div className="flex flex-col gap-2">
        {detailPath && (
          <Link
            to={detailPath}
            data-testid={`product-details-${product.id}`}
            className="bg-white text-[#1E1E24] border-2 border-[#1E1E24] rounded-full shadow-[4px_4px_0px_0px_#1E1E24] hover:-translate-y-0.5 hover:bg-[#F4F1EA] transition-all font-bold tracking-wide px-6 py-2 flex items-center justify-center gap-2 text-sm"
          >
            View details
          </Link>
        )}
        <a
          href={product.amazon_url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackAmazonClick(product)}
          data-testid={`product-cta-${product.id}`}
          className="bg-[#FF5A5F] text-white border-2 border-[#1E1E24] rounded-full shadow-[4px_4px_0px_0px_#1E1E24] hover:-translate-y-0.5 hover:shadow-[6px_6px_0px_0px_#1E1E24] transition-all font-bold tracking-wide px-6 py-2 flex items-center justify-center gap-2 text-sm"
        >
          {product.cta_text || "See on Amazon"}
          <span aria-hidden="true">→</span>
        </a>
      </div>
    </div>
  );
}
